import * as React from 'react';
import HyperLinkRenderer from 'components/common/DataGridDevEx/CustomRenderers/HyperLinkRenderer';

const HyperLinkCell = ({ data }) => {

    return <HyperLinkRenderer value={{ Quote: data.value, FieldValue: data.value }} colDef={{ headerName: 'customer quote' }} link='customer-quote-enquiry/quote-details' />;
};

export default HyperLinkCell;
